
import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./MainCard.css";

export default function MainCard({ id, content, slug, img, title, name }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/News/mqalat/${id}/${slug}`);
  };
 
  return (
    <div className="col-lg-6 mb-4 mt-3" style={{ height: "408px" }}>
      <div
        className="card main-card h-100"
        onClick={handleClick}
        style={{ cursor: "pointer" }}
      >
        <img
          src={img}
          className="card-img-top main-card-img"
          alt="Main Image"
          style={{ height: '420px', objectFit: 'cover' }}
        />
        <div className="card-img-overlay d-flex flex-column justify-content-end bg-dark bg-opacity-50">
          <h5 className="card-title text-white text" style={{ lineHeight: "1.6" }}>
            {title}
          </h5>
        </div>
      </div>
    </div>
  );
}
